export default {
	'accounts-configs': 'Configuraciones de cuentas',
	'items-configs': 'Configuraciones de artículos'
}